export default {
  getLanguage(lang) {
    if (lang && lang !== 'zh_TW' && lang !== 'zh_CN') {
      return lang.split('_')[0];
    }
    return lang;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/common.js